export default __webpack_public_path__ + "static/social-daily-report_en-a9e64de010404db8a297020424d194ce.png";